'use client'
import { FC } from 'react'
import { LoginPageTab } from '@/root/shared-types/ui/ui-types'
import { AuthSection } from '@/root/modules/tuuleliinid/LoginPage/components/AuthSection/AuthSection'
import { RecoverySection } from '@/root/modules/tuuleliinid/LoginPage/components/RecoverySection/RecoverySection'
import { useCustomRouter } from '@/root/shared-hooks'

export const LoginPage: FC = () => {
  const { params } = useCustomRouter()
  const view = (params?.tab as LoginPageTab) ?? 'signup'

  return (
    <div className="flex w-full justify-center">
      {view === 'signup' && <AuthSection variant="signup" />}
      {view === 'login' && <AuthSection variant="login" />}
      {view === 'recovery' && <RecoverySection />}
    </div>
  )
}
